module.exports = __webpack_public_path__ + "static/media/workingmemory-words-6.fe3d6f4a.mp3";